import styled from 'styled-components';
import { Form } from '@unform/web';
import { TextInfo } from '../../components/TextInfo';
import { Select as SelectComponent } from '../../components/Select';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { colors } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 520px;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled(Form)`
  padding: 0 28px 28px;

  h2 {
    font-size: 24px;
    font-weight: 700;
    color: ${colors.onSurface};

    margin-bottom: 16px;
  }
`;

//    INFO

export const ContainerInfo = styled.div`
  margin: 0 28px 15px;
`;

export const Info = styled(TextInfo)`
  span {
    font-size: 13px;
  }
`;

//    DATA SUBSCRIPTION

export const ContainerDataSubscription = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1199px) {
    border: none;
    height: auto;
  }
`;

export const DataSubscription = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${colors.outlineVariant}40;

  font-size: 15px;
  font-weight: 600;
  color: ${colors.onSurface};

  width: 100%;

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & > span {
    color: ${colors.onSurfaceVariant};
    font-weight: 400;
  }

  &:last-child {
    margin-top: 16px;
    border-bottom: none;

    & > span {
      font-size: 20px;
      font-weight: 800;
      color: ${colors.primary};
    }
  }
`;

export const Select = styled(SelectComponent)`
  /* width: 60px;
  height: 25px; */

  .react-select__input-container {
    display: none;
  }

  .react-select__control {
    flex: 1;
    flex-direction: row;
    max-width: 150px;
    /* background-color: blue; */
  }

  .react-select__menu-list {
    flex-direction: column;
    width: 100%;
  }
`;

export const Submit = styled(ButtonConfirm)`
  margin: 40px auto;
  margin-bottom: 0;
`;
